import { useEffect, useRef, useState } from 'react';

interface IUseDynamicDescriptionWidthOptions {
  offset?: number;
  minWidth?: number;
  maxWidth?: number;
}

export const useDynamicDescriptionWidth = (options: IUseDynamicDescriptionWidthOptions = {}) => {
  const { offset = 30, minWidth = 50, maxWidth } = options;

  const containerRef = useRef<HTMLDivElement>(null);
  const [descriptionWidth, setDescriptionWidth] = useState<string | undefined>(undefined);

  useEffect(() => {
    const updateDescriptionWidth = () => {
      if (containerRef.current) {
        const parentWidth = containerRef.current.getBoundingClientRect().width;
        let calculatedWidth = Math.max(minWidth, parentWidth - offset);

        // Apply max width if specified
        if (maxWidth) {
          calculatedWidth = Math.min(calculatedWidth, maxWidth);
        }

        setDescriptionWidth(`${calculatedWidth}px`);
      }
    };

    // Initial calculation
    updateDescriptionWidth();

    // Create ResizeObserver to watch for size changes
    const resizeObserver = new ResizeObserver(() => {
      updateDescriptionWidth();
    });

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [offset, minWidth, maxWidth]);

  return {
    containerRef,
    descriptionWidth
  };
};
